<template>
  <div class="liquor-detail-header-select" :class="{'liquor-detail-header-select-top': isTop}">
    <div class="title">{{title}}</div>
    <div class="buttons" :style="`width: ${list.length * 110}px`">
      <div
        class="button"
        :class="{'button-active': item.active}"
        v-for="(item, index) in list"
        :key="index"
        @click="onClick(item)"
      >{{item.name}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LiquorHeaderSelect",
  props: {
    list: {
      type: Array,
      required: true
    },
    top: {
      type: Number,
      default: 500
    },
    title: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      scrollTop: 0
    };
  },
  computed: {
    isTop: function() {
      return this.scrollTop > this.top;
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll(e) {
      this.scrollTop = e.target.documentElement.scrollTop;
    },
    onClick(e) {
      this.list.map(e => (e.active = false));
      e.active = true;
    }
  }
};
</script>

<style lang="scss">
$button-group-primary-color: #333;
$button-group-second-color: rgba(228, 200, 150, 1);

.liquor-detail-header-select {
  width: 100%;
  height: 60px;

  .title {
    float: left;
    margin-left: calc((100% - 1100px) / 2);
    height: 60px;
    line-height: 60px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }

  .buttons {
    margin: 15px auto;
    height: 28px;

    border: 1px solid #333;

    .button {
      display: inline-block;
      width: 110px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: #333;

      background: #fff;

      cursor: pointer;
    }

    .button-active {
      background: #333;
      color: #fff;
      cursor: default;
    }
  }
}

.liquor-detail-header-select-top {
  position: fixed;
  top: 70px;
  z-index: 999;
  background: rgba(0, 0, 0, 1);

  .buttons {
    border: 1px solid $button-group-second-color;

    .button {
      background: rgba(0, 0, 0, 1);
      color: $button-group-second-color;
    }

    .button-active {
      color: #000000;
      background: $button-group-second-color;
    }
  }
}
</style>